import { __assign, __awaiter, __generator, __read } from "tslib";
import React, { useEffect, useState } from 'react';
import { app } from '@ekuaibao/whispered';
import { getDeptItemsByIds, getExternalStaffItemByIds, getRoleItemByIds, getStaffItemByIds, tagLabelLimit } from './utile';
import { isString } from '@ekuaibao/helpers';
import TagShow from '../tag-show';
import SubCollectionTip from '../sub-collection-tip';
export var StaffSelectSingle = function (_a) {
    var value = _a.value, placeholder = _a.placeholder, onValueChange = _a.onValueChange, disabled = _a.disabled, includeChildrenToolTipStr = _a.includeChildrenToolTipStr, _b = _a.isIncludeChildren, isIncludeChildren = _b === void 0 ? defaultIncludeChildren : _b, subIncludeStr = _a.subIncludeStr, _c = _a.type, type = _c === void 0 ? 'staff' : _c, _d = _a.multiple, multiple = _d === void 0 ? true : _d, className = _a.className, _e = _a.tagStrLimit, tagStrLimit = _e === void 0 ? 20 : _e, tooltipIconStyle = _a.tooltipIconStyle, _f = _a.blackList, blackList = _f === void 0 ? {} : _f, includeSubWrapperStyle = _a.includeSubWrapperStyle, maxTagCount = _a.maxTagCount;
    var _g = __read(useState([]), 2), tags = _g[0], setTags = _g[1];
    useEffect(function () {
        parseValue();
    }, [value, type]);
    var parseValue = function () { return __awaiter(void 0, void 0, void 0, function () {
        var t;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, valueParse(value, type, isIncludeChildren)];
                case 1:
                    t = _a.sent();
                    setTags(t);
                    return [2];
            }
        });
    }); };
    var handleSelect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectDataMap, data, checkedList, checkedValues, val;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    selectDataMap = {
                        staff: {
                            type: 'department-member',
                            checkIds: (_a = getCheckedIdsFromValue(value)) !== null && _a !== void 0 ? _a : []
                        },
                        department: {
                            type: 'department',
                            checkIds: (_b = getCheckedIdsFromValue(value)) !== null && _b !== void 0 ? _b : []
                        },
                        role: {
                            type: 'role',
                            checkIds: (_c = getCheckedIdsFromValue(value)) !== null && _c !== void 0 ? _c : []
                        },
                        external: {
                            type: 'external',
                            checkIds: (_d = getCheckedIdsFromValue(value)) !== null && _d !== void 0 ? _d : []
                        }
                    };
                    data = Array.isArray(type) ? type.map(function (t) { return selectDataMap[t]; }) : [selectDataMap[type]];
                    return [4, app.open('@organizationManagement:SelectStaff', {
                            title: Array.isArray(type) ? getTitle(type[0]) : getTitle(type),
                            multiple: multiple,
                            blackListValue: blackList,
                            data: data
                        })];
                case 1:
                    checkedList = _e.sent();
                    checkedValues = Array.isArray(type)
                        ? checkedList.reduce(function (result, v) { return result.concat(v.checkIds); }, [])
                        : checkedList[0].checkIds || [];
                    val = __assign(__assign({}, value), { value: getValueFromCheckedIds(checkedValues, multiple) });
                    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(val);
                    return [2];
            }
        });
    }); };
    var handleChange = function (values) {
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(__assign(__assign({}, value), { value: getValueFromCheckedIds(values, multiple) }));
    };
    var handleIncludeChildren = function (e) {
        e.stopPropagation();
        var val = __assign(__assign({}, value), { include: e.target.checked });
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(val);
    };
    console.log(value);
    return (React.createElement("div", { className: className },
        React.createElement(TagShow, { placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : i18n.get('请选择人员'), tags: tags, disabled: disabled, onClick: handleSelect, onChange: handleChange, tagLabelLimit: function (tag) { return tagLabelLimit(tag, tagStrLimit); }, maxTagCount: maxTagCount }),
        !!subIncludeStr && (React.createElement(SubCollectionTip, { wrapperStyle: includeSubWrapperStyle, checked: value.include, onChange: handleIncludeChildren, subIncludeStr: subIncludeStr, includeChildrenToolTipStr: includeChildrenToolTipStr, tooltipIconStyle: tooltipIconStyle }))));
};
var getCheckedIdsFromValue = function (value) {
    return value.value && isString(value.value) ? [value.value] : value.value;
};
var getValueFromCheckedIds = function (checkedIds, isMultiple) {
    if (checkedIds === void 0) { checkedIds = []; }
    var data = checkedIds.filter(function (item) { return item !== 'departmentsIncludeChildren'; });
    return isMultiple ? data : data[0];
};
var defaultIncludeChildren = function (value) {
    return value === null || value === void 0 ? void 0 : value.include;
};
var valueParse = function (value, type, isIncludeChildren) {
    if (type === void 0) { type = 'staff'; }
    if (isIncludeChildren === void 0) { isIncludeChildren = defaultIncludeChildren; }
    return __awaiter(void 0, void 0, void 0, function () {
        var v, dataSourceMap, data, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!value) {
                        return [2, []];
                    }
                    v = isString(value.value) ? [value.value] : value.value;
                    dataSourceMap = {
                        staff: getStaffItemByIds(v),
                        department: getDeptItemsByIds(v),
                        role: getRoleItemByIds(v),
                        external: getExternalStaffItemByIds(v)
                    };
                    data = [];
                    if (!Array.isArray(type)) return [3, 2];
                    return [4, Promise.all(type.map(function (t) { return dataSourceMap[t](); }))];
                case 1:
                    data = _a.sent();
                    data = data.reduce(function (result, v) { return result.concat(v); }, []);
                    return [3, 4];
                case 2: return [4, dataSourceMap[type]()];
                case 3:
                    data = _a.sent();
                    _a.label = 4;
                case 4:
                    result = [];
                    if (isIncludeChildren(value)) {
                        result.push({
                            id: 'departmentsIncludeChildren',
                            label: i18n.get('含子部门'),
                            showAvatar: false,
                            tagOptions: { color: 'pri', fill: 'outline', closable: false }
                        });
                    }
                    return [2, result.concat(data)];
            }
        });
    });
};
var getTitle = function (type) {
    if (type === void 0) { type = 'staff'; }
    var titleMap = {
        staff: i18n.get('选择人员'),
        department: i18n.get('选择部门'),
        role: i18n.get('选择角色')
    };
    return titleMap[type];
};
export default StaffSelectSingle;
